import { withStyles } from '@material-ui/styles';
import HubFormTitle from './HubFormTitle';
import styles from './styles';

export default withStyles(styles)(HubFormTitle);
